// extracted by mini-css-extract-plugin
export default {"dataManager":"dataManager_dataManager__ruysZ","table":"dataManager_table__7LdfN","addNewEntity":"dataManager_addNewEntity__wXodE","searchForm":"dataManager_searchForm__mib5p"};